import { push } from 'connected-react-router';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { DatacenterApi } from 'vrlcm-gui-api';
import {
  RequestDatacenters,
  requestDatacentersFailed,
  requestDatacentersSuccess,
  UpdateDatacenter,
  updateDatacenterFailed,
  updateDatacenterSuccess,
  UpdateVCenter,
  updateVCenterFailed,
  updateVCenterSuccess
} from '../actions/Datacenters';
import * as Constants from '../constants/action-constants';
import { ROUTES } from '../constants/RouteConstants';

function* getDatacenters(action: RequestDatacenters) {
  try {
    const { fetchChildren } = action.payload;
    const dataCentersApi = fetchChildren
      ? DatacenterApi.getDatacentersWithChildren
      : DatacenterApi.getDatacenters;
    const datacenters = yield call(dataCentersApi);
    yield put(requestDatacentersSuccess(fetchChildren, datacenters));
  } catch (error) {
    yield put(requestDatacentersFailed());
  }
}

function* watchForDatacenters() {
  yield takeLatest(Constants.REQUEST_DATACENTERS, getDatacenters);
}

function* updateDatacenter(action: UpdateDatacenter) {
  try {
    const { datacenter, isEdit } = action.payload;
    const updatedDatacenter = yield call(
      DatacenterApi.updateDatacenter,
      datacenter,
      isEdit
    );
    yield put(updateDatacenterSuccess(updatedDatacenter, isEdit));
    yield put(
      push(
        `${ROUTES.DATACENTERS}?dataCenterVmid=${updatedDatacenter.dataCenterVmid}`
      )
    );
  } catch (error) {
    yield put(updateDatacenterFailed());
  }
}

function* watchForUpdateDatacenter() {
  yield takeLatest(Constants.UPDATE_DATACENTER, updateDatacenter);
}

function* updateVCenter(action: UpdateVCenter) {
  try {
    const { isEdit, dataCenterVmid, vCenter } = action.payload;
    yield call(DatacenterApi.updateVCenter, dataCenterVmid, vCenter, isEdit);
    yield put(updateVCenterSuccess(isEdit, dataCenterVmid, vCenter));
    yield put(push(`${ROUTES.DATACENTERS}?dataCenterVmid=${dataCenterVmid}`));
  } catch (error) {
    yield put(updateVCenterFailed());
  }
}

function* watchForUpdateVCenter() {
  yield takeLatest(Constants.UPDATE_VCENTER, updateVCenter);
}

export default function* datacenterSaga() {
  yield all([
    watchForDatacenters(),
    watchForUpdateDatacenter(),
    watchForUpdateVCenter()
  ]);
}
